import { useEffect, useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqItems } from "@/mocks/siteData";

export default function Faq() {
  const [open, setOpen] = useState<string>(faqItems[0]?.q ?? "");

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "faq-jsonld";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqItems.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    const parent = document.getElementById("root")?.parentElement;
    parent?.appendChild(script);
    return () => {
      const node = document.getElementById("faq-jsonld");
      node?.remove();
    };
  }, []);

  const toggle = (q: string) => setOpen((cur) => (cur === q ? "" : q));

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 px-4 py-16 md:px-6 md:py-24 lg:grid-cols-[0.9fr_1.4fr]">
        <div className="lg:sticky lg:top-24 lg:self-start">
          <SectionHeading
            kicker="FAQ"
            title="常见问题 · 你可能想问"
            subtitle="关于内容来源、更新频率与如何追更，我们挑了几条读者常问的先回答清楚。"
          />
          <a
            href="#subscribe"
            onClick={(e) => {
              e.preventDefault();
              const el = document.getElementById("subscribe");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-200 bg-background-50 px-5 py-2.5 text-sm font-bold text-primary-700 transition-colors hover:bg-primary-100"
          >
            还有疑问？留下线索
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => {
            const isOpen = open === item.q;
            return (
              <div key={item.q} className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
                <button
                  type="button"
                  onClick={() => toggle(item.q)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="font-heading text-[15px] font-bold text-foreground-950 md:text-base">{item.q}</span>
                  <span
                    className={`inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-background-50 transition-colors ${
                      isOpen ? "bg-primary-500" : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-sm`} />
                  </span>
                </button>
                {isOpen ? (
                  <div className="border-t border-background-100 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}